// extracted by mini-css-extract-plugin
export default {"dialog":"RecurrenceDeleteDialog_dialog__HKAT-","actions":"RecurrenceDeleteDialog_actions__tBudY","optionButton":"RecurrenceDeleteDialog_optionButton__ASgX3"};